import req from '@sportninja/common/api/request'
import { useCallback, useState } from 'react'

export interface Highlight {
  id: string
  game_id: string
  player_id: string
  team_id: string
  title: string
  body: string
  video_url: string
  thumbnail_url: string
  video_duration: string
  type?: string
  teamSide?: 'Home' | 'Visitor'
  playerName?: string
  teamName?: string
}

/**
 * Custom hook for fetching game highlights
 * @param gameId - The ID of the game to fetch highlights for
 * @returns Object containing data, loading state, error, and refetch function
 */
export const useHighlights = (gameId?: string) => {
  const [data, setData] = useState<Highlight[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  const fetchData = useCallback(async () => {
    if (!gameId) {
      return
    }

    setLoading(true)
    setError(null)

    try {
      const response = await req(`/games/${gameId}/highlights`)
      setData(response.data)
    } catch (err) {
      setError(
        err instanceof Error
          ? err
          : new Error('An error occurred while fetching highlights')
      )
    } finally {
      setLoading(false)
    }
  }, [gameId])

  return {
    data,
    loading,
    error,
    refetch: fetchData,
  }
}
